import { Injectable, inject } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { UserRoleService } from '../services/role/user-role.service';
import { TaasOrganizationContextService } from '../services/organization/taas-organization-context.service';
import { Role } from '../models/roles.enum';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
//TODO: remove usage of deprecated functions / interfaces
export class RoleAuthGuard implements CanActivate, CanActivateChild {

  private userRoleService = inject(UserRoleService);
  private orgContext = inject(TaasOrganizationContextService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkRoleAccess(route);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkRoleAccess(childRoute);
  }

  private checkRoleAccess(route: ActivatedRouteSnapshot): boolean | UrlTree {
    // Get required roles from route data
    const requiredRoles: Role[] = this.getRequiredRoles(route);

    // Deny access when required roles are declared and the user has none of them
    if (requiredRoles.length > 0 && !this.userRoleService.hasAnyRole(requiredRoles)) {
      return this.router.parseUrl('/no-access');
    }

    // Redirect to home when the route needs HSM permissions but the org lacks them
    if (this.routeRequiresManageHsmPermissions(route) && !this.orgContext.canManageHsm) {
      return this.router.parseUrl('/home');
    }

    return true;
  }

  /**
   * Get required roles from route data, checking current route and parent routes
   */
  private getRequiredRoles(route: ActivatedRouteSnapshot): Role[] {
    // Check current route data first
    if (route.data?.['requiredRoles']) {
      return route.data['requiredRoles'] as Role[];
    }

    // If no roles found in current route, check parent routes
    let parent = route.parent;
    while (parent) {
      if (parent.data?.['requiredRoles']) {
        return parent.data['requiredRoles'] as Role[];
      }
      parent = parent.parent;
    }

    // No required roles found
    return [];
  }

  /**
   * Returns true when the route or any parent declares the ifCanManageHsm flag
   */
  private routeRequiresManageHsmPermissions(route: ActivatedRouteSnapshot): boolean {
    let current: ActivatedRouteSnapshot | null = route;
    do {
      if (current.data?.['ifCanManageHsm']) {
        return true;
      }
      current = current.parent;
    } while (current);

    return false;
  }
}
